import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './style';

const OrderStatusLabel = ({ searchStatus = {}, orders }) => {
  const extra = searchStatus.bgColor === '#FFF' ? 'white' : '';

  return (
    <styles.SearchResultStatusLabelContainer
      className={`header-result ${extra}`}
      bgColor={searchStatus.bgColor}
      borderColor={searchStatus.borderColor}
      color={searchStatus.color}
    >
      <styles.StatusText>{searchStatus.label}</styles.StatusText>
      <styles.QtdFiltered>{orders} resultados</styles.QtdFiltered>
    </styles.SearchResultStatusLabelContainer>
  );
};

OrderStatusLabel.propTypes = {
  searchStatus: PropTypes.object.isRequired,
  orders: PropTypes.number.isRequired,
};

export default OrderStatusLabel;



// WEBPACK FOOTER //
// ./src/components/OrderStatusLabel/index.js